import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./SidebarLink.module.scss";
import vectorUp from '../../../assets/vectorUp.svg';
import vectorDown from '../../../assets/vectorDown.svg';

export interface ISidebarNavLink {
    name: string;
    svgIcon: string;
    enabled?: boolean;
    path?: string;
    links?: ISidebarNavLink[];
}

interface SidebarLinkProps {
    link: ISidebarNavLink;
    basePath: string;
    collapsed: boolean;
    isExpanded: boolean;
    onToggle: () => void;
    onActive: (name: string) => void;
    isNew?: boolean;
    rootLinkName?: string;
}

const SidebarLink: React.FC<SidebarLinkProps> = ({
                                                            link,
                                                            basePath,
                                                            collapsed,
                                                            isExpanded,
                                                            onToggle,
                                                            onActive,
                                                            isNew = false,
                                                            rootLinkName = '',
                                                        }) => {
    const hasSubLinks = !!link.links?.length;

    if (isNew) {
        const isRootActive = link.name === rootLinkName;
        return (
            <span className={`${isRootActive ? styles.inActiveSidebarDetailLink : styles.inActiveSidebarLink} ${styles.navLink}`}>
                <img src={link.svgIcon} alt="" />
                {!collapsed && <span>{link.name}</span>}
            </span>
        );
    }

    const generatePath = (subPath?: string) => `${basePath}/${subPath?.toLowerCase() || ''}`;

    if (hasSubLinks) {
        return (
            <>
                <div
                    role="button"
                    tabIndex={0}
                    className={`${styles.navLink} ${isExpanded ? styles.expanded : ''} `}
                    onClick={onToggle}
                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onToggle()}
                >
                    <img src={link.svgIcon} alt="" />
                    {!collapsed && (
                        <>
                            <span>{link.name}</span>
                            <span className={styles.arrowIcon} style={{ marginLeft: 'auto', display: 'flex' }}>
                                <img src={isExpanded ? vectorUp : vectorDown} alt="" style={{ height: 8 }} />
                            </span>
                        </>
                    )}
                </div>
                {isExpanded && (
                    <ul className={`${styles.subMenu} ${collapsed ? styles.subMenuCollapsed : ''}`}>
                        {link.links?.map((sub) => (
                            <li key={sub.name}>
                                <NavLink
                                    to={generatePath(sub.path)}
                                    className={({ isActive }) => isActive ? styles.active : ''}
                                    onClick={() => onActive(sub.name)}
                                >
                                    {sub.svgIcon && <img className={styles.subLinkImg} src={sub.svgIcon} alt="" />}
                                    {!collapsed && <span>{sub.name}</span>}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                )}
            </>
        );
    }

    return (
        <NavLink
            to={generatePath(link.path)}
            className={({ isActive }) => isActive ? `${styles.active} ${styles.navLink}` : styles.navLink}
            onClick={() => onActive(link.name)}
        >
            <img src={link.svgIcon} alt="" />
            {!collapsed && <span>{link.name}</span>}
        </NavLink>
    );
};

export default SidebarLink;
